























































































import { Component, Mixins } from "vue-property-decorator";
import ServiceCard from "@/components/cards/ServiceCard.vue";
import PlaceholderCard from "@/components/cards/PlaceholderCard.vue";
import ButtonCommon from "@/components/lib/ButtonCommon.vue";
import SolutionsPreviewSection from "@/components/SolutionsPreviewSection.vue";
import ContactForm from "@/components/contact/ContactForm.vue";
import viewMetaMixin from "@/mixins/viewMetaMixin";
import fetchServiceTypeMixin from "@/mixins/fetchServiceTypeMixin";
import { onLoadJumpMixin } from "@/mixins/onScrollAnimationMixin";
import { IServiceType, ISeparatedServiceTypes } from "@/entities";

@Component({
  components: {
    ServiceCard,
    PlaceholderCard,
    ButtonCommon,
    SolutionsPreviewSection,
    ContactForm,
  },
})
export default class Services extends Mixins(
  viewMetaMixin,
  onLoadJumpMixin,
  fetchServiceTypeMixin
) {
  protected fetching: boolean = false;
  protected services: IServiceType[] = [];

  mounted() {
    this.$store.dispatch("setCheckboxLabelColor", true);
  }

  get servicesToShow(): IServiceType[] {
    return this.services.filter((service: IServiceType) => service.validate());
  }

  get separatedServices(): IServiceType[] {
    let services: IServiceType[] = [];

    this.servicesToShow.forEach((service: IServiceType) => {
      services.push(service);
    });
    return services;
  }

  get name(): string {
    return this.$storage.getters.getPlatformInfo().name;
  }

  get mayHaveOtherServices(): boolean {
    return !!this.otherServices.length || this.fetching;
  }

  get otherServices(): IServiceType[] {
    // move plan in center
    let services = this.separatedServices;
    services.forEach((service: IServiceType, index: number) => {
      if (service.type === "plan" && index !== 1) {
        let plan = services.splice(index, 1)[0];
        services.splice(1, 0, plan);
      }
    });
    return services;
  }

  private getPromoCode(): void {
    this.$storage.actions.setModal({
      name: "ModalCertificate",
      from: "services",
    });
  }
}
